module.exports = __webpack_public_path__ + "img/welcome-to-real-white.31b35699.svg";